export { default as ClockClockwiseSolidIcon } from './ClockClockwiseSolidIcon';
